import { useMemo } from "react";

import { useLobApi } from "../../../hooks/useLobApi";
import type { SiteLobData } from "../types";

interface VisitsBreakdownResponse {
    Data: {
        [domain: string]: SiteLobData;
    };
}

const ENDPOINT = "api/websiteContent/lob/BarChart";

export const useVisitsBreakdownData = () => {
    const { data: response, isLoading } = useLobApi<VisitsBreakdownResponse>(ENDPOINT, "lob-bar-chart");

    const data = useMemo(() => response?.Data ?? null, [response]);
    return {
        data,
        isLoading,
    };
};
